<template >
  <template
      v-if="
      structure
      && structure.specialDisplay
      && structure.specialDisplay == 'businessUnitStatus'
    "
  >

    <div
      v-if="structure.btns"
      class="x"
    >
      <router-link
          v-for="(btnItem, btnIndex)  in structure.btns"
          :to="btnItem.uri"
          class="btn btn-warning me-2 mb-2 fw-medium"
      >
        <i v-if="btnItem.ico" :class="btnItem.ico + '  me-1'"></i>
        <span v-if="btnItem.title">{{btnItem.title}}</span>
      </router-link>
    </div>

    <h1 class="text-secondary">{{ structure.title }}</h1>
    <template
        v-if="structure.units"
    >
      <div
          v-for="(unit) in structure.units"
          class="card"
      >
        <div
            class="card-header fw-medium bg-primary text-white"
        >
          <h4 class="">{{unit.title}}</h4>
        </div>

        <div
            class="card-body"
        >
          <ul
              v-if="semafor[unit.id] && semafor[unit.id].times"
              class="list-group list-group-flush"
          >
            <li
                v-for="(item, s_index) in semafor[unit.id].times"
                class="list-group-item d-flex justify-content-between align-items-center">

              <div class="d-flex align-items-center">
                <div class="form-check form-switch me-3 form-switch-status-color">
                  <input
                      v-model="semafor[unit.id].times[s_index].open"
                      :id="unit.id + '-' + s_index + '_open'"
                      type="checkbox"
                      placeholder="vypln text"
                      class="form-check-input"
                      value="1"
                  >
                </div>

                <label
                    class="form-check-label"
                    :for="unit.id + '-' + s_index + '_open'"
                >
                  <span
                      v-if="calculateMinutesBetween(semafor[unit.id].times[s_index].from.date, semafor[unit.id].times[s_index].to.date) <= 1440"
                      v-format-date="semafor[unit.id].times[s_index].from.date"
                  >
                  </span>
                  <span
                      v-else
                      v-format-date-range="{
                        from: semafor[unit.id].times[s_index].from.date,
                        to: semafor[unit.id].times[s_index].to.date
                      }"
                  ></span>

                </label>
              </div>

              <div class="text-muted">
                <i
                    @click.prevemt="removeSemafor(unit.id, s_index)"
                    class="bi bi-x fs-1"
                />
              </div>
            </li>
          </ul>
        </div>

        <div
            class="card-footer"
        >
          <template
              v-if="structure.times"
          >
            <template
                v-for="(btn) in structure.times"
            >
              <div
                  v-if="btn.type == 'btn'"
                  @click.prevent="addSemaforStatus(unit, btn)"
                  class="btn btn-sm btn-outline-primary me-1 mb-1"
              >
                {{ btn.title }}
              </div>
              <template
                  v-else-if="btn.type == 'range'"
              >
              <span
                  @click.prevent="this.form.semafor.display = !this.form.semafor.display ;"
                  class="btn btn-sm btn-outline-primary me-1 mb-1"
              >
                {{ btn.title }}
              </span>
              </template>

            </template>

            <div
                v-if="this.form.semafor.display"
                class="row g-2"
            >
              <div
                  class="col"
              >
                <input
                    v-model="form.semafor.from"
                    type="datetime-local"
                    class="form-control"
                    placeholder="Od"
                />
              </div>

              <div
                  class="col"
              >
                <input
                    v-model="form.semafor.to"
                    type="datetime-local"
                    class="form-control"
                    placeholder="Do"
                />

              </div>

              <div
                  class="col"
              >
                <button
                    @click.prevent="submitSemaforStatus(unit)"
                    class="btn btn-primary"
                >
                  Pridat
                </button>
              </div>

            </div>

          </template>
        </div>
      </div>


      <display-debug>
        <template #debugView>status: {{status}}</template>
      </display-debug>

      <!--
      <div class="mt-1">
        <div
            class="text-success w-100"
        >
          <i class="bi bi-check-circle-fill me-2"/>
          <span>Text je ok</span>

        </div>
      </div>
      -->

      <div
        class="d-flex justify-content-center align-items-center mt-2"
      >
        <button
          @click.prevent="submitSemafor()"
          class="btn btn-outline-secondary -rounded-pill mt-1"
        >
          Ulozit
        </button>

        <span v-if="this.isChange">
          je zmena
        </span>


      </div>
    </template>


    <display-debug>
      <template #debugView>semafor {{semafor}}</template>
    </display-debug>

    <display-debug>
      <template #debugView>structure FULL {{structure}}</template>
    </display-debug>

  </template>

  <display-debug>
    <template #debugView>structure X structure {{structure}}</template>
  </display-debug>




</template>

<script>

import axios from "axios";

export default {
  name: 'businessUnitOpenStatus',
  components: {

  },
  props: [
    "structure"
  ],
  data() {
    return {
      savedData: {
        data: null,
        timer: null,
        delay: 1000
      },
      isChange: false,
      semafor: {},
      status: {
        is: null,
        text: null,
        ico: null,
      },
      form: {
        semafor: {
          display: false,
          from: null,
          to: null,
          open: true
        }
      },
    }
  },
  methods: {
    async submitSemafor() {
//      console.log('dev.submitSemafor',  this.structure.submit);

      const formData = new FormData;
      formData.append('semafor_data', JSON.stringify(this.semafor))

      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.structure.submit.action,
        method: this.structure.submit.method,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        console.log('dev.submitSemafor res', res);
      });


    },
    async removeSemafor(unitId, index) {
      if (confirm('Opravdu chcete tento zaznam odstranit?')) {
        //delete this.inputModel[ident];

        if(this.semafor[unitId].times[index].id) {
          console.log('dev.removeSemafor REMOVE DATA', this.semafor[unitId].times[index]);
          //

          const formData = new FormData;
          formData.append('time', JSON.stringify(this.semafor[unitId].times[index]))
          formData.append('business_unit', unitId)

          axios.defaults.baseURL = this.getBaseRoot();
          await axios({
            url: this.structure.remove_time.action,
            method: this.structure.remove_time.method,
            data: formData,
            withCredentials: true,
            headers: this.getRequestHeader(),
          }).then((res) => {
            console.log('dev.removeSemafor res DATA', res);
            this.semafor[unitId].times.splice(index, 1);
          });


        }else{
          this.semafor[unitId].times.splice(index, 1);
        }
      }



    },
    submitSemaforStatus(unit) {

      if(
          this.form.semafor.from
          && this.form.semafor.to
      ) {
        this.form.semafor.err = null;
        const time = {
          range: {
            from: this.form.semafor.from,
            to: this.form.semafor.to
          }
        };
        this.addSemaforStatus(unit, time);


      }else{
        this.form.semafor.err = 'nejsou vyplnene data od nebo do';


      }

      console.log('dev.submitSemaforStatus', unit, this.form.semafor);
    },
    async addSemaforStatus(unit, time) {
      //console.log('dev.addSemaforStatus', unit, time);
      //console.log('dev.addSemaforStatus', time.range);


      const formData = new FormData;
      formData.append('semafor_data', JSON.stringify(this.semafor))

      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.structure.submit.action,
        method: this.structure.submit.method,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        console.log('dev.submitSemafor res', res);
      });




      const t = {
        id: null,
        open: true,
        from: {
          date: time.range.from
        },
        to: {
          date: time.range.to
        },
      }

      this.form.semafor.display = false;

      //TODO overeni
      if(
          this.isExistDateRange(unit.id, time.range.from, time.range.to)
      ) {

      }else{
        this.status.is = false;
        this.status.text = 'jiz existuje tenhle rozsah';
      }

      this.semafor[unit.id].times.push(t);

      console.log('dev.addSemaforStatus', t, this.semafor[unit.id].times);
    },

    isExistDateRange(unitId, from, to) {
      console.log('dev.isExistDaterange', unitId, from, to);

      return false;
    },
    isDeepEqual(a, b) {
      // 1. Rychlá kontrola reference (včetně primitiv)
      if (a === b) return true;

      // 2. Kontrola, zda jsou oba objekty a nejsou null
      if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
        return false;
      }

      // 3. Kontrola, zda jsou stejného typu (např. Objekt vs. Pole)
      if (Array.isArray(a) !== Array.isArray(b)) return false;

      const keysA = Object.keys(a);
      const keysB = Object.keys(b);

      // 4. Kontrola počtu klíčů
      if (keysA.length !== keysB.length) return false;

      // 5. Rekurzivní kontrola klíčů a hodnot
      for (const key of keysA) {
        // Kontrola, zda má druhý objekt stejný klíč a zda jsou hodnoty hluboce stejné
        if (!Object.prototype.hasOwnProperty.call(b, key) || !this.isDeepEqual(a[key], b[key])) {
          return false;
        }
      }

      return true;
    },


    calculateMinutesBetween(start, end) {
      start = new Date(start)
      end = new Date(end)


      // Kontrola platnosti vstupů
      if (!(start instanceof Date) || isNaN(start.getTime()) ||
          !(end instanceof Date) || isNaN(end.getTime())) {
        console.error("calculateMinutesBetween: Vstup musí být platný Date objekt.");
        return null; // Návrat null při neplatném vstupu
      }

      // 1. Získání časové hodnoty v milisekundách (Unix time)
      const startTimeMs = start.getTime();
      const endTimeMs = end.getTime();

      // 2. Výpočet absolutního rozdílu v milisekundách
      // Použijeme Math.abs, aby výsledek byl vždy kladný bez ohledu na pořadí datumů.
      const differenceMs = Math.abs(endTimeMs - startTimeMs);

      // 3. Převod milisekund na minuty
      // 1 sekunda = 1 000 ms
      // 1 minuta = 60 sekund = 60 * 1 000 ms = 60 000 ms
      const minutes = differenceMs / 60000;

      // Vrácení celého čísla minut (zaokrouhlení na nejbližší celé číslo)
      return Math.round(minutes);

      // Pokud byste potřeboval přesný desetinný počet minut, použijte jen:
      // return differenceMs / 60000;
    },

  },
  mounted() {
    //semafory
    if(
        typeof this.structure != "undefined"
        && this.structure
        && this.structure.specialDisplay
        && this.structure.specialDisplay == 'businessUnitStatus'
        && this.structure.units
    ) {
      for(const i in this.structure.units) {
        //console.log('dev unit', this.structure.units[i].statuses)
        this.semafor[this.structure.units[i].id] = {
          unit_id: this.structure.units[i].id,
          times: [],
        }
        if(
            this.structure.units[i].statuses
        ) {
          for(const j in this.structure.units[i].statuses) {
            //console.log('dev status', this.structure.units[i].statuses[j])
            const x = {
              j: j
            };

            this.semafor[this.structure.units[i].id].times.push(this.structure.units[i].statuses[j])
          }
        }


      }



      this.savedData.data = {...this.semafor };
    }

    //this.getData(this.modul)
  },
  watch: {
    semafor: {
      handler(newval, oldVal) {
        //console.log('dev watch semafor A', newval, oldVal)
        if(
            typeof oldVal !== 'undefined'
        ) {

          if(this.savedData.timer) clearInterval(this.savedData.timer);
          this.savedData.timer = setTimeout(
              () => {
                //console.log('dev watch semafor B', this.isDeepEqual(this.semafor.data, this.savedData))

                if(this.isDeepEqual(this.semafor.data, this.savedData)) {
                  console.log('dev watch semafor c', newval, this.savedData)
                  this.isChange = true;
                }
              },
              this.savedData.delay
          )



        }


      },
      deep: true,
      immediate: true
    },

    inputModel( newVal){
      //this.$emit('update:modelValue', newVal ) // model vole!
    },
  },
}
</script>
<style lang="scss" scoped>
/* 1. Definice třídy pro přepínač s dynamickou barvou */
.form-switch-status-color .form-check-input {
  /* Výchozí (nezaškrtnutý) stav: ČERVENÁ (Danger) */
  background-color: #dc3545; /* Barva $danger */
  border-color: #dc3545;     /* Barva $danger */

  /* Nastavení, aby ikonka (tečka) byla vidět na červeném pozadí */
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}

/* 2. Definice aktivního (zaškrtnutého) stavu */
.form-switch-status-color .form-check-input:checked {
  /* Aktivní (zaškrtnutý) stav: ZELENÁ (Success) */
  background-color: #198754; /* Barva $success z Bootstrapu */
  border-color: #198754;     /* Barva $success z Bootstrapu */

  /* Barva ikonky na zeleném pozadí zůstane bílá, viz výše */
}

</style>


